import { ShouldRenderTabsService } from '@philips-emr/hpms-provider-commons';
import { TabControlAPI, TabWithContentAPI } from '@philips-emr/tws-components';
import Controller, { OnMount } from '@philips-emr/tws-core/lib/client';
import { MountEvent } from '@philips-emr/tws-core/lib/component/types';

import { FragmentNames } from '../../codegen';
import { AccreditationServiceMaterialsAliases as Aliases } from '../../codegen/constants/aliases/accreditation-service-materials-aliases';
import BaseController from '../BaseController';

enum ServicesType {
  PROCEDURES = 'procedures',
  MATERIALS = 'materials',
  OUTSOURCED_SERVICES = 'outsourcedServices',
  SERVICES = 'services'
}

@Controller({ fragment: FragmentNames.ACCREDITATION_SERVICE_MATERIALS })
export default class AccreditationServicesMaterialsController extends BaseController {

  @OnMount(Aliases.TAB_CONTROL)
  onMountTab(event: MountEvent): void {
    const api = event.target as TabControlAPI;
    const { nrSeqAccreditation } = this.historyService.getCurrentRouteParams();
    this.context.set({ nrSeqAccreditation });
    ShouldRenderTabsService.chooseDefaultTab(api, [ServicesType.PROCEDURES, ServicesType.MATERIALS, ServicesType.OUTSOURCED_SERVICES, ServicesType.SERVICES]);
  }

  @OnMount(Aliases.TAB_WITH_CONTENT_PROC)
  onMountProcedures(event: MountEvent): void {
    const api = event.target as unknown as TabWithContentAPI;
    ShouldRenderTabsService.shouldRenderTab(api, ServicesType.PROCEDURES);
  }

  @OnMount(Aliases.TAB_WITH_CONTENT_MAT)
  onMountProMaterials(event: MountEvent): void {
    const api = event.target as unknown as TabWithContentAPI;
    ShouldRenderTabsService.shouldRenderTab(api, ServicesType.MATERIALS);
  }

  @OnMount(Aliases.TAB_WITH_CONTENT_OUTSOURCED_SERVICES)
  onMountOutsourcedServices(event: MountEvent): void {
    const api = event.target as unknown as TabWithContentAPI;
    ShouldRenderTabsService.shouldRenderTab(api, ServicesType.OUTSOURCED_SERVICES);
  }

  @OnMount(Aliases.TAB_WITH_CONTENT_SERVICES)
  onMountServices(event: MountEvent): void {
    const api = event.target as unknown as TabWithContentAPI;
    ShouldRenderTabsService.shouldRenderTab(api, ServicesType.SERVICES);
  }
}

export {
  AccreditationServicesMaterialsController,
};
